export default __webpack_public_path__ + "app/assets/images/logos/pandora.png";